<template>
  <nav v-if="sections.length" class="fixed right-4 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col gap-3 bg-white p-2 rounded-lg shadow-lg">
    <a
      v-for="section in sections"
      :key="section.id"
      :href="`#${section.id}`"
      :title="section.label"
      class="relative group w-3.5 h-3.5 rounded-full border border-gray-400 transition-all flex items-center justify-center"
      :class="activeSection === section.id ? 'bg-primary border-primary scale-110' : 'bg-white hover:bg-gray-200'"
    >
      <span class="absolute right-full mr-2 px-2 py-1 bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        {{ section.label }}
      </span>
    </a>
  </nav>
</template>

<script lang="ts" setup>
import { ref, watchEffect, onMounted, onBeforeUnmount } from 'vue'

interface Section {
  id: string
  label: string
}

const props = defineProps<{
  sections: Section[]
}>()

const activeSection = ref<string>('')
let observer: IntersectionObserver

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activeSection.value = entry.target.id
        }
      })
    },
    { threshold: 0.3 }
  )

  props.sections.forEach((s) => {
    const el = document.getElementById(s.id)
    if (el) observer.observe(el)
  })
})

onBeforeUnmount(() => {
  observer?.disconnect()
})

watchEffect(() => {
  // ensure active section exists in current list
  if (!props.sections.find((s) => s.id === activeSection.value)) {
    activeSection.value = ''
  }
})
</script> 